import { factory } from "../../../utils/apiThunkFactory"

export const changeRole = factory.post("ActiveConference/changeRole", "/api/bookings/update-participant-role");
export const sendConferenceMessage = factory.post("ActiveConference/sendConferenceMessage", "/api/messages/sendConferenceMessage");